module.exports = __webpack_public_path__ + "img/bt-4-off.175fa8bd.png";